module.exports = __webpack_public_path__ + "static/media/person-icon-1675.2af5a660.png";